import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';

const PlayerLoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twofaCode, setTwofaCode] = useState(''); // ✅ NEW
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('http://127.0.0.1:8000/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          twofa_code: twofaCode, // ✅ NEW
        }),
      });

      console.log('Lgoinresponse:', response);

      const data = await response.json();
      console.log('Login response data:', data);

      if (!response.ok) {
        setError(data.detail || 'Login failed.');
        setLoading(false);
        return;
      }

      // Store token and player info
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify({
        id: data.user_id,
        name: data.name,
        role: data.role,
        email: data.email,
      }));

      // Redirect to player dashboard
      navigate('/workouts');
    } catch (err) {
      console.error(err);
      setError('An error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleLogin} sx={{ maxWidth: 400, margin: 'auto', mt: 8 }}>
      <Typography variant="h5" gutterBottom>
        Player Login
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      {/* ✅ NEW FIELD FOR 2FA */}
      <TextField
        label="2FA Code"
        type="text"
        value={twofaCode}
        onChange={(e) => setTwofaCode(e.target.value)}
        fullWidth
        margin="normal"
        //required
        inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }} 
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Login'}
      </Button>
    </Box>
  );
};

export default PlayerLoginForm;
